import Nav from '../components/Nav';
import Footer from '../components/Footer';

function OrderComplete() {
    return (
        <>
            <Nav />
            <div className="bg-gray200 p-4">
            <div className=" relative">
                <div className="absolute text-white text-center font-bold text-xl w-full justify-center mt-8 ">Order Completed</div>
                <img src="/imgs/bn-top.jpg" />
             </div>
             <div className="mt-4 border shadow-lg bg-white p-4">
                 <h2 className="text-2xl font-bold text-gray-800 uppercase">your order is confirmed</h2>
                 <h3 className="text-sm p-2 text-gray-600">An email has been sent to our mail address client@gmail.com</h3>
             </div>
             <div className="mt-4 p-4 border shadow-lg">
                 <h2 className="text-xl font-bold text-gray-70 text-center border-b p-2 pb-4 uppercase">order Items</h2>
                 <div className="mt-4 grid grid-cols-3">
                     <div className=''>
                         <img src="/imgs/hoddie.jpg" className="w-12 h-12" />
                     </div>
                     <div className='text-sm'>
                         <h3 class="text-gray-700">Hoddie</h3>
                         <h3 class="text-gray-700">Size: S</h3>
                          <h3 class="text-gray-700">Color: Orange</h3>
                         
                     </div>
                     <div className='text-sm'>
                        Ghc 20.00 X 1
                        Ghc 20.00
                     </div>
                     
                     

                 </div>
                 <div className="mt-4 w-full p-2 flex">
                     <div className="w-2/3 text-left">
                         <ul className="w-full">
                             <li className="p-2">SubTotal</li>
                             <li className="p-2">Shipping and handling</li>
                             <li className="p-2 font-bold font-gray-800">TOTAL(tax excl.)</li>
                         </ul>
                     </div>
                     <div class=" text-yellow-600 text-right">
                         <ul>
                             <li className="p-2">Ghc 20.00</li>
                             <li className="p-2">Ghc 7.00</li>
                             <li className="p-2" >Ghc 27.00</li>
                         </ul>
                     </div>
                 </div>

                 <h2 className="text-xl font-bold text-gray-70 text-center border-b p-2 mt-4 pb-4 uppercase">order Details</h2>
                 <div className="text-gray-600 text-sm text-center p-2">
                     Order reference: GOODGIRLS<br />
                     Payment Method: Bank Transfer<br />
                     Shipping method: My Carrier <br />
                     Delivery in Two Days
                 </div>
             </div>
             </div>

        </>
    )
}

export default OrderComplete;